import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import parser from 'ua-parser-js';
import App from './containers/App/App';
import './styles/bootstraptable.css';
import './theme/styles/mediaqueries.css';
import './styles/styles.css';
import history from "./utils/history";

import createProvider from "./containers/ProviderWithErrBoundary";
import rootReducer from "./reducers";
import thunk from "redux-thunk";

const ua = parser(navigator.userAgent);
let platform;
if (ua.os.name === 'Windows' || ua.os.name === 'Ubuntu' || ua.os.name === 'Linux' || ua.os.name === 'Mac OS') {
  platform = 'Desktop';
} else if (ua.os.name === 'Android' || ua.os.name === 'iOS' || ua.os.name === 'BlackBerry') {
  platform = 'Tablet';
} else { platform = 'Other'; }
localStorage.setItem('platform', platform);
let configDet= window._env.app.head//{...config.app.head}

const AppProvider = createProvider(rootReducer, thunk)

render(
  <AppProvider>
    <Helmet {...configDet}/>
    <BrowserRouter history={history}>
      <App />
    </BrowserRouter>
  </AppProvider>,
  document.getElementById("content")
);
